/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
import optionsUtil from '../../../objects/optionsUtil.js';
//import 'code-mirror';
import $ from 'jquery';
//import enableCM from 'knockout-code-mirror';
//import CodeMirror from 'code-mirror';
import inLineStyleObj from '../../../objects/inLineStyleObj';


class inLineStyleModel {

    constructor() {
        // Profile
        this.componentName = ko.observable("header");
        this.context = context;
        this.selectedItem = ko.observable(this.returnDefaultItem()).extend({ notify: 'always' });
        this.selectedItemID = ko.observable(0);

        this.id = this.context.util.guid();
        this.sampleId = this.context.util.guid();
        this.editorId = this.context.util.guid();
        this.visible = ko.observable(true);

        //Help
        this.helpVisible = ko.observable(false);
        this.helpMessage = ko.observable("");


        this.listArray = context.inLineStyleArray;
        this.contentVisible = ko.observable(false);

        this.addButtonLabel = ko.computed(function() {
            
            let retStr = "Add";

            if(this.selectedItem().hasOwnProperty('id'))
            {
                if(this.selectedItem().id !== "0")
                {
                    return "Update";
                }
            }
            
            return retStr;

        }, this);

        this.handleClear();

    }

    updateHelp(message) {
        this.helpVisible(true);
        this.helpMessage(message);
    }

    updateCode(vm) {
        console.log("inLineStyleEditor:updateCode: vm: %o", vm);
        //console.log(vm);
        
        let editor =  $('#' + vm.editorId + ' .CodeMirror')[0].CodeMirror;
        //console.log(editor);
        console.log(editor.getValue());
        vm.selectedItem().styleCode(editor.getValue());
        this.updateStyle(vm.selectedItem().inLineStyle());

        vm.updateHelp("A refresh is required to enable these changes.")
        
    }

    showSampleCSS() {
        
        //this.context.eventManager.notifySubscribers({helpTitle:"Sample CSS",helpHtml:"styleName { <br> color: gray; <br> font-size: 14px; <br> font-weight: bold; <br> font-family: Arial, Helvetica, sans-serif; <br> }", helpTitleCss:""},"show-help-modal");
    }


    updateStyle(style) {
        $('#' + this.sampleId).attr('style' , '' + style + '');
    }

    returnDefaultItem() {
        return new inLineStyleObj({"subid" : "", "createdate" : "", "id" : null, "styleCode" : "StyleName { color: black; }","styleName" : "StyleName", "styleType" : "inLine"});
        //return retnObj;
    }

    toggleContent() {
        this.contentVisible(!this.contentVisible());

        /*
        if(this.contentVisible())
        {
            this.getData();
        }
        */
    }

    getData() {
        
        let oUtil = new optionsUtil(this.context);
        let self = this;
        this.handleClear();
        this.listArray([]);

        oUtil.getInlineStyles("inline").then(function (result) {
            self.context.inLineStyleArray(result);
            //self.listArray(result);
            console.log(self.listArray());
        });

    }

    handleClick(model,item) {

        console.log("inLineStyleEditor:handleClick:");
        console.log(model);
        console.log(item);

        let selectedIndex = item.target.selectedIndex -1;

        if(selectedIndex < 0)
        {
            this.selectedItem(this.returnDefaultItem());
        }
        else
        {
            this.selectedItem(this.listArray()[selectedIndex]);
        }

        console.log("inLineStyleEditor:handleClick: selectedItem: %o", this.selectedItem());

        this.updateStyle(this.selectedItem().inLineStyle());

    }

    cleanSelectedItemBeforeSave() {
        //this.selectedItem().styleCode = this.selectedItem().styleCode.replace(/[\n\r]+/g, '').trim();
        //this.selectedItem().styleName = this.selectedItem().styleName.replace(/[\n\r]+/g, '').trim();
    }

    handleUpdateData() {
        console.log("inLineStyleEditor:handleUpdateData:");
        this.cleanSelectedItemBeforeSave();
        console.log(this.selectedItem());

        let oUtil = new optionsUtil(this.context);
        let self = this;

        oUtil.updateInlineStyles(this.selectedItem()).then(function (result) {
            console.log("inLineStyleEditor:handleUpdateData: result: %o", result);
            console.log(result.request);

            if(result.request.status !== 200)
            {
                self.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error processing updateInlineStyles: " + result},"messageModel");
            }
            else
            {
                //self.getData();
                context.getInlineStyles();
            }
        });

    }

    handleClear() {
        this.selectedItem(this.returnDefaultItem());
    }

    handleDelete() {

        console.log("inLineStyleEditor:handleDelete:");

        let oUtil = new optionsUtil(this.context);
        let self = this;

        oUtil.deleteStyles(this.selectedItem()).then(function (result) {
            console.log(result);
            if(result.request.status !== 200)
            {
                self.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error processing delete Styles: " + result},"messageModel");
            }
            else
            {
                self.getData();
            }
        });
    }
    
}

export default { viewModel: inLineStyleModel, template: require('!raw-loader!./inLineStyleEditor.html') };


// WEBPACK FOOTER //
// ./src/components/options/inLineStyleEditor/inLineStyleEditor.js